<template>
  <Modal>
    <Modal.Media full-bleed>
      <div class="flex justify-center pt-[48px] pb-[18px]">
        <div class="w-[265px]">
          <MembershipCard
            :name="userName"
            interactive
            shadow
            class="relative w-full"
          />
        </div>
      </div>
    </Modal.Media>
    <Modal.Title>Welcome to your<br />Dacr Pro Membership</Modal.Title>
    <Modal.Body>
      Take advantage of all benefits your membership has to offer. Register your
      first work today.
    </Modal.Body>
    <Modal.Footer layout="vertical">
      <Button variant="primary" size="lg" @click="close()">Continue</Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Modal, Button, useModal } from '@dacr/library'

import MembershipCard from '@/shared/components/MembershipCard.vue'
import { useUserStore } from '@/shared/stores/user'

const { close } = useModal()
const userStore = useUserStore()

const userName = computed(() => userStore.user?.name ?? 'Jessica Ramsey')
</script>
